import { GetDataConnectionsListDocument, GetDataConnectionsListQuery } from "@hydrologiq/gql-experience/graphql"
import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"

export type DataConnectionListItem = GetDataConnectionsListQuery["getDataConnectionsList"][number]

export function useDataConnectionsList() {
  const { data, loading, error, refetch } = useQueryWithEndpoint<GetDataConnectionsListQuery>(
    GetDataConnectionsListDocument,
    { fetchPolicy: "cache-and-network" },
    "primary",
  )
  return { connections: data?.getDataConnectionsList ?? [], loading, error, refetch }
}
